const Nav = () => {
    const menuToggleEl = document.querySelector(".js-navigation-toggle");
    const searchToggleEl = document.querySelector(".js-search-toggle");
    const body = document.body;

    if (menuToggleEl) {
        const headerEl = document.querySelector(".js-header");

        menuToggleEl.addEventListener("click", () => {
            body.classList.toggle("overflow-hidden");
            headerEl.classList.toggle("c-header--open");
        });
    }

    if (searchToggleEl) {
        const searchEl = document.querySelector(".js-search");
        const overlayEl = document.querySelector(".js-search-overlay");
        const fieldEl = document.querySelector(".js-search-field");

        searchToggleEl.addEventListener("click", () => {
            body.classList.toggle("overflow-hidden");
            searchEl.classList.toggle("c-search--open");

            // focus search field input
            fieldEl.focus();
        });

        // close popup if user clicks outside of the popup
        overlayEl.addEventListener("click", (event) => {
            const isOutside = !event.target.closest(".c-search__form");

            if (isOutside) {
                searchEl.classList.remove("c-search--open");
                body.classList.toggle("overflow-hidden");
            }
        });
    }
};

export default Nav;
